import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const FinanceiroGrafico = ({ 
  titulo, 
  tipo = 'bar', 
  dados, 
  className = '',
  opcoesPersonalizadas = {},
  mostrarTitulo = true
}) => {
  const canvasRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (!canvasRef.current || !dados) return;

    const ctx = canvasRef.current.getContext('2d');
    const styles = getComputedStyle(document.documentElement);
    const textMuted = styles.getPropertyValue('--text-muted').trim() || '#6B7280';
    const textPrimary = styles.getPropertyValue('--text-primary').trim() || '#111827';
    const border = styles.getPropertyValue('--border').trim() || 'rgba(0, 0, 0, 0.08)';
    const surface = styles.getPropertyValue('--surface').trim() || '#ffffff';
    
    // Configurações padrão do gráfico
    const opcoesPadrao = {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        intersect: false,
        mode: 'index'
      },
      layout: {
        padding: {
          top: 10,
          bottom: 10,
          left: 10,
          right: 10
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          grid: {
            color: border
          },
          ticks: {
            color: textMuted,
            maxTicksLimit: 8,
            callback: function(value) {
              if (dados.formatoMoeda) {
                return 'R$ ' + value.toLocaleString();
              }
              return value.toLocaleString();
            }
          }
        },
        x: {
          grid: {
            display: false
          },
          ticks: {
            color: textMuted,
            maxTicksLimit: 10
          }
        }
      },
      plugins: { 
        legend: { 
          display: dados.mostrarLegenda !== false,
          labels: {
            color: textMuted,
            boxWidth: 12,
            padding: 20
          }
        },
        tooltip: {
          backgroundColor: surface,
          titleColor: textPrimary,
          bodyColor: textPrimary,
          borderColor: border,
          borderWidth: 1,
          padding: 12,
          usePointStyle: true
        }
      },
      elements: {
        bar: {
          borderRadius: 4
        }
      }
    };

    // Mesclar opções personalizadas
    const opcoesFinais = {
      ...opcoesPadrao,
      ...opcoesPersonalizadas
    };

    chartInstance.current = new Chart(ctx, {
      type: tipo,
      data: dados,
      options: opcoesFinais
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [dados, tipo, opcoesPersonalizadas]);

  return (
    <div className={`bg-[color:var(--surface)] p-4 rounded-lg border border-[color:var(--border)] theme-shadow ${className}`}>
      {mostrarTitulo && (
        <h3 className="text-base font-semibold text-[color:var(--text-primary)] mb-3">{titulo}</h3>
      )}
      <div className="h-80">
        <canvas ref={canvasRef}></canvas>
      </div>
    </div>
  );
};

export default FinanceiroGrafico;

